"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YEAR_MS = exports.TIME_ZONE_MOSCOW = void 0;
exports.TIME_ZONE_MOSCOW = 'Europe/Moscow';
exports.YEAR_MS = 31536000000;
